const DEBUG_FLAG = String(process.env.VUE_APP_DEBUG || "").toLowerCase();
const DEBUG_NAMESPACES = String(process.env.VUE_APP_DEBUG_NAMESPACES || "")
  .split(",")
  .map((value) => value.trim())
  .filter(Boolean);

function canDebug(namespace) {
  if (DEBUG_FLAG === "true" || DEBUG_FLAG === "1") {
    return true;
  }

  if (process.env.NODE_ENV !== "production") {
    return true;
  }

  return DEBUG_NAMESPACES.includes("*") || DEBUG_NAMESPACES.includes(namespace);
}

function write(method, namespace, args) {
  if (typeof console === "undefined" || typeof console[method] !== "function") {
    return;
  }

  console[method](`[${namespace}]`, ...args);
}

export function createLogger(namespace) {
  return {
    debug(...args) {
      if (!canDebug(namespace)) {
        return;
      }

      write("debug", namespace, args);
    },
    info(...args) {
      if (!canDebug(namespace)) {
        return;
      }

      write("info", namespace, args);
    },
    warn(...args) {
      write("warn", namespace, args);
    },
    error(...args) {
      write("error", namespace, args);
    },
  };
}

export default createLogger("app");
